export default function getAmountLabel(count: number, unit: string) {
  const formattedCount = count.toLocaleString('en-US');
  const formattedUnit = count === 1 || count === -1 ? unit : `${unit}s`;
  return `${formattedCount} ${formattedUnit}`;
}
